(function(){
  if(window.__crReportLanguageBound)return;
  window.__crReportLanguageBound=true;
  // Sync repeated purchase forms only for the same product, within this page.
  // No storage, personal information, analytics or inferred language.
  document.addEventListener('change',function(event){
    var selected=event.target;
    if(!selected.matches('[data-cr-report-language]'))return;
    document.querySelectorAll('[data-cr-report-language]').forEach(function(other){
      if(other.dataset.product===selected.dataset.product)other.value=selected.value;
    });
  });
})();
